import { render, staticRenderFns } from "./RatePlanMapping.vue?vue&type=template&id=4b238170&scoped=true&"
import script from "./RatePlanMapping.vue?vue&type=script&lang=js&"
export * from "./RatePlanMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b238170",
  null
  
)

export default component.exports